import {inject, Injectable} from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler, HttpHandlerFn,
  HttpInterceptor,
  HttpInterceptorFn,
  HttpRequest
} from '@angular/common/http';
import {catchError, finalize, Observable, throwError} from "rxjs";
import {HTTP_PARAMS_CONSTANTS} from '../constants/http/http-params.constants';
import {APPLICATION_ROUTES_CONSTANTS} from '../constants/application-routes.constants';
import {Router} from '@angular/router';
import {LoadingService} from '../../shared/services/loading.service';

export const loadingInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {
  const loadingService = inject(LoadingService);
  loadingService.show();

  return next(req).pipe(finalize(() => loadingService.hide()));
};
